const recaptchaState = {
  DONE_LOADING: 'DONE_LOADING',
  ERROR_LOADING: 'ERROR_LOADING',
  LOADING: 'LOADING',
  NOT_LOADED: 'NOT_LOADED',
};

const utmQueryFieldConsts = {
  firstTouch: 'first_touch',
  firstTouchTimestamp: 'first_touch_timestamp',
  utmCampaign: 'utm_campaign',
  utmContent: 'utm_content',
  utmMedium: 'utm_medium',
  utmSource: 'utm_source',
  utmTerm: 'utm_term',
};

const utmMarketingFields = {
  [utmQueryFieldConsts.firstTouch]: 'first_touch__c',
  [utmQueryFieldConsts.firstTouchTimestamp]: 'first_touch_date_time__c',
  [utmQueryFieldConsts.utmCampaign]: 'FreeAccount_UTM_Campaign__c',
  [utmQueryFieldConsts.utmContent]: 'FreeAccount_UTM_Content__c',
  [utmQueryFieldConsts.utmMedium]: 'FreeAccount_UTM_Medium__c',
  [utmQueryFieldConsts.utmSource]: 'FreeAccount_UTM_Source__c',
  [utmQueryFieldConsts.utmTerm]: 'FreeAccount_UTM_Term__c',
};

export default {
  recaptchaState,
  utmQueryFieldConsts,
  utmMarketingFields,
};
